module.exports = __webpack_public_path__ + "img/2025-05-09a_2.d74484a9.jpg";